import {CustomFieldTO} from 'generated/JavaTO'
import {CF} from 'module/CustomField/util/CustomField'
import {isNullCFMember} from 'module/CustomField/util/isNullCFMember'
import _ from 'lodash'
import {CFMember, CFValue, isCFMember} from 'module/CustomField/type/CFType'

export function isEqualCFValue(val1: CFValue | CFMember, val2: CFValue | CFMember, cfDef?: CustomFieldTO): boolean {
	if (val1 === val2 || val1 == null && val2 == null) return true;
	if (cfDef ? CF.isNull(cfDef, val1) : isNullCFMember(val1)) val1 = null
	if (cfDef ? CF.isNull(cfDef, val2) : isNullCFMember(val2)) val2 = null
	if (isCFMember(val1) && val1?.lazy) val1 = _.omit(val1, 'data', 'preview', 'lazy')
	if (isCFMember(val2) && val2?.lazy) val2 = _.omit(val2, 'data', 'preview', 'lazy')
	return _.isEqual(val1, val2)
}